var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.397,
    height: 126.509,
    viewBox: "0 0 131.397 126.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63396",
    "data-name": "Group 63396",
    transform: "translate(-231.286 -999.849) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8716",
    "data-name": "Rectangle 8716",
    width: 40,
    height: 16,
    transform: "translate(940 474)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63395",
    "data-name": "Group 63395"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8717",
    "data-name": "Rectangle 8717",
    width: 40,
    height: 16,
    transform: "translate(940 590)",
    fill: "#fe3b1f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8722",
    "data-name": "Rectangle 8722",
    width: 40,
    height: 16,
    transform: "translate(1020.598 572.313) rotate(135)",
    fill: "#00ce7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8721",
    "data-name": "Rectangle 8721",
    width: 40,
    height: 16,
    transform: "translate(1009.284 519) rotate(-135)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8723",
    "data-name": "Rectangle 8723",
    width: 40,
    height: 16,
    transform: "translate(910.716 561) rotate(45)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8718",
    "data-name": "Rectangle 8718",
    width: 40,
    height: 16,
    transform: "translate(1010 560) rotate(-90)",
    fill: "#cddb00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.be544ecd0c9f0083ef9bac6ba54858ae.svg";
export { ForwardRef as ReactComponent };